import React, { useMemo, useState, useEffect } from "react";
import { Avatar, Tooltip } from "@material-ui/core";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Close,
} from "@material-ui/icons";
import styles from "./Style.module.css";
import ChatComponent from "../../views/Messaging/List/component/chatComponent/MessagingFields";
import ChatAvatarItem from "./ChatAvatarItem.component";

function FloatingChatWindow({
  dm,
  positionIndex,
  cardWidth = 330,
  cardHeight = 520,
  rightPos,
  onClose,
  onToggleMinimize,
  fetchChatInfo,
  isHidden,
}) {
  const [localChatUser, setLocalChatUser] = useState(dm);

  useEffect(() => {
    setLocalChatUser(dm);
  }, [dm]);

  const profileInfo = useMemo(() => {
    if (localChatUser?.meta_data) {
      return localChatUser.meta_data;
    }
    return {
      label: localChatUser?.name || localChatUser?.meta_data?.label || "Chat",
      description: localChatUser?.code || localChatUser?.meta_data?.description || "",
      image: localChatUser?.image || localChatUser?.meta_data?.image || "",
      initials: localChatUser?.initials || localChatUser?.meta_data?.initials || "",
      display_type: localChatUser?.display_type || localChatUser?.meta_data?.display_type || "",
    };
  }, [localChatUser]);

  const isMinimized = Boolean(dm?.isMinimized);

  const computedRight =
    typeof rightPos === "number" ? rightPos : 366 + positionIndex * 342;

  return (
    <div
      className={`${styles.windowContainer} ${
        isMinimized ? styles.windowMinimized : styles.windowOpen
      }`}
      style={{
        right: `${computedRight}px`,
        width: `${cardWidth}px`,
        height: isMinimized ? "48px" : `${cardHeight}px`,
        transform: isHidden ? "translateY(150%)" : "translateY(0)",
        opacity: isHidden ? 0 : 1,
        pointerEvents: isHidden ? "none" : "auto",
        transition: "transform 0.4s ease-in-out, opacity 0.4s ease-in-out, height 0.3s ease",
      }}
    >
      <div
        className={styles.windowHeader}
        onClick={() => onToggleMinimize(dm)}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px", overflow: "hidden", flex: 1 }}>
          <ChatAvatarItem
            image={profileInfo?.image}
            initials={profileInfo?.initials}
            label={profileInfo?.label}
            displayType={profileInfo?.display_type}
            isGroup={dm?.type === "GROUP" || profileInfo?.is_group}
            size={30}
          />

          <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div className={styles.chatTitle} style={{ fontSize: "0.82rem" }}>
              {profileInfo?.label}
            </div>
            {profileInfo?.description && !isMinimized && (
              <div className={styles.chatDes} style={{ fontSize: "0.68rem" }}>
                {profileInfo?.description}
              </div>
            )}
          </div>
        </div>

        <div className={styles.headerActions}>
          <Tooltip title={isMinimized ? "Expand" : "Minimize"}>
            <div
              className={styles.iconBtn}
              onClick={(e) => {
                e.stopPropagation();
                onToggleMinimize(dm);
              }}
            >
              {isMinimized ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
            </div>
          </Tooltip>
          <Tooltip title="Close">
            <div
              className={styles.iconBtn}
              onClick={(e) => {
                e.stopPropagation();
                onClose(dm);
              }}
            >
              <Close fontSize="small" />
            </div>
          </Tooltip>
        </div>
      </div>

      {!isMinimized && (
        <div className={styles.windowBody}>
          <ChatComponent
            chatUser={localChatUser}
            setChatUser={setLocalChatUser}
            fetchChatInfo={fetchChatInfo}
            isFloatingChat={true}
          />
        </div>
      )}
    </div>
  );
}

export default FloatingChatWindow;
